export default {"src":"/_next/static/media/Checkmark.b6687eaa.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};